module.exports = __webpack_public_path__ + "img/logout.a49df3c3.svg";